export default __webpack_public_path__ + "static/d-miller-30592bd7e5191029ef07bec0c82042fd.png";